module.exports = __webpack_public_path__ + "static/media/features2a@2x.154ca978.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/features2a@2x.png
 ** module id = 901
 ** module chunks = 0
 **/